import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { projectService } from '@/services/http/projectService'

type UseGetUsersProjectProps = {
  projectId: string
  enabled?: boolean
}

export const useGetUsersProject = ({
  projectId,
  enabled = true,
}: UseGetUsersProjectProps) => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['usersProject', projectId],
    queryFn: () => projectService.project.getUsersProject({ projectId }),
    enabled,
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar os usuários do projeto',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    return {
      usersProject: data,
      isLoading,
      refetchUsersProject: refetch,
    }
  }

  return {
    usersProject: [],
    isLoading,
    refetchUsersProject: refetch,
  }
}
